import { Button, BUTTON_TYPES } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { ACTIONS, SUBJECTS } from 'features/PRS/Abilities'
import { subject } from '@casl/ability'
import { usePRSDetailsActions } from '../Providers/PRSDetailsActionsProvider'
import { usePRSDetailsContext } from '../Providers/PRSDetailsContextProvider'
import { Can } from '../Providers/PrsDetailsAbilityProvider'
import { usePRSDetailsPopupContext } from '../Providers/PRSDetailsPopupProvider'
import Popup from 'components/Popup/Popup'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { setLoading } from 'redux/store/common/slice'
import { patchTrial } from 'pages/ProductRequests/api'
import {
  PRS_STATUSES,
  PRS_STATUSES_MESSAGES
} from 'pages/ProductRequests/constants'
import { useDispatch } from 'react-redux'
import { notification } from 'components/Notification'
export default () => {
  const prsDetailsActions = usePRSDetailsActions()
  const prsDetailsContext = usePRSDetailsContext()
  const popup = usePRSDetailsPopupContext()
  const { sendPrsPopup } = popup
  const dispatch = useDispatch()

  const { data } = prsDetailsContext.state
  const { handleGetPRSData } = prsDetailsContext.actions
  const onSend = () => {
    dispatch(setLoading(true))
    patchTrial(data.uuid, {
      status: PRS_STATUSES.TRIAL_COMPLETED
    })
      .then(() => {
        handleGetPRSData()
        notification.success({
          message: `${PRS_STATUSES_MESSAGES.trial_completed}`
        })
        close()
      })
      .catch((err) => {
        notification.error({
          message: err.data?.details[0]
        })
      })
      .finally(() => {
        dispatch(setLoading(false))
        close()
      })
  }
  return (
    <Can I={ACTIONS.COMPLETE} a={subject(SUBJECTS.TRIAL, { ...data })}>
      <Button
        type={BUTTON_TYPES.DEFAULT}
        onClick={prsDetailsActions.handleSendPrs}
        upperCase
      >
        {BTN_TXT.COMPLETE_TRIAL_REQUEST}
      </Button>
      <Popup
        visible={sendPrsPopup.state.visible}
        onCancel={sendPrsPopup.actions.close}
        title={`Complete trial request?`}
        width={442}
        footer={
          <>
            <Button
              onClick={sendPrsPopup.actions.close}
              type={BUTTON_TYPES.DEFAULT}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button type={BUTTON_TYPES.PRIMARY} upperCase onClick={onSend}>
              {BTN_TXT.COMPLETE}
            </Button>
          </>
        }
      >
        <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
          You will not be able to start trial again after completion. Do you
          want to mark trial as completed?
        </Typography.Headline6>
      </Popup>
    </Can>
  )
}
